import { STATUS_OPTIONS } from '../home.js';

/* The Status filter used on Home, Summary and Validation: Up to date / Behind / Missing / All statuses (the Home page's status of each report). */
export default function StatusSelect({ id, value, onChange }) {
  return (
    <>
      <label htmlFor={id}>Status</label>
      <select id={id} className="ui dropdown" value={value} onChange={(e) => onChange(e.target.value)}>
        {STATUS_OPTIONS.map(([v, label]) => <option key={v || 'all'} value={v}>{label}</option>)}
      </select>
    </>
  );
}
